import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Tools from './Tools';
import { DashboardIcon, UserRoundedIcon, ViewIcon, RefreshIcon, BotIcon, UserIcon, ExecIcon, ArrowIcon, DownloadIcon, DownloadingIcon, CalendarIcon} from './icons/svgIcons';
import Sidebar from './Sidebar';
import UserMenu from './UserMenu';
import MoreMenu from './ui/moreMenu/MoreMenu';
import { Tabs, Tab, Content } from "./Tab";
import '../components/css/chatDashboard.css';

import TimeAgo from 'javascript-time-ago';
import es from 'javascript-time-ago/locale/es.json';
import ReactTimeAgo from 'react-time-ago';

import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import DatePicker from 'react-modern-calendar-datepicker';
import ModalWindow from './ModalWindow';
import ReactHtmlParser from 'react-html-parser';

const ChatDashboard = (props) => {

    
    const [loading, setLoading] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [currentStatusContactCenter, setCurrentStatusContactCenter] = useState(false);
    const [data, setData] = useState({});
    const [currentStatusChatExecutives, setCurrentStatusChatExecutives] = useState([]);
    const [attentionsByExecutive,setAttentionsByExecutive] = useState([]);
    const [interactionsCount, setInteractionsCount] = useState(0); 
    const [allSessionsCount, setAllSessionsCount] = useState(0); 
    const [allExecSessionsCount, setAllExecSessionsCount] = useState(0); 
    const [allBotSessionsCount, setAllBotSessionsCount] = useState(0); 
    const [activeTab, setActiveTab] = useState(0);
    const [selectedDayRange, setSelectedDayRange] = useState({ from: null, to: null });

    const [attentionsByExecutiveByDates, setAttentionsByExecutiveByDates] = useState([]);
    const [allSessionsCountByDates, setAllSessionsCountByDates] = useState(0);
    const [allExecSessionsCountByDates, setAllExecSessionsCountByDates] = useState(0);
    const [allBotSessionsCountByDates, setAllBotSessionsCountByDates] = useState(0);
    const [interactionsCountByDates, setInteractionsCountByDates] = useState(0); 

    const [showSessionsPopup, setShowSessionsPopup] = useState(false);
    const [sessions, setSessions] = useState([]);

    const [currentSessionId, setCurrentSessionId] = useState(null);
    const [interactions, setInteractions] = useState([]);

    const [sessionsPagination, setSessionsPagination] = useState(null);
    const [currentSessionsFilter, setCurrentSessionsFilter] = useState(null);
    const [sessionsWindowTitle, setSessionsWindowTitle] = useState(null);
    const [downloadStart, setDownloadStart] = useState(false);
    const [sessionData, setSessionData] = useState({});


    const handleChange = (event) => {
        if (event.target.checked) {
            enableContactCenter('true');
        } else {
            enableContactCenter('false');
        }
    }


    useEffect(() => {
        setSessionData(JSON.parse(sessionStorage.getItem('sessionData')));

        TimeAgo.addDefaultLocale(es);
        getCcStatus();
        refreshValues();
    }, []);

    useEffect(() => {
        if (selectedDayRange.to!==null){
            refreshValuesByDate();
        }
    }, [selectedDayRange]);

    useEffect(() => {
        if (currentSessionId){
            getChatSession(currentSessionId)
        }
    }, [currentSessionId]);


    const getChatSession = (chatSessionId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatConversation`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { sessionId: chatSessionId }
        };
        axios(options).then(response => {
            setInteractions(response.data.conversation);
        })
        .catch((error) => {
            console.log("Error:", error.message);
            //setError(error.message);
        });
    }

    const getCurrentStatusChatExecutives =()=>{
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatDashboard_currentStatusChatExecutives`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        axios(options).then(response => {
            setLoading(false);
            setCurrentStatusChatExecutives(response.data.currentChatSessions);

        }).catch(function (error) {
            console.log("Error:", error.message);
            //setError(error.message);
            setLoading(false);
        });
    }

    const getAttentionsByExecutive = (filterDate=null) => {
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatDashboard_attentionsByExecutive`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };

        if (filterDate){
            options.params.filterDate = filterDate;
        }

        axios(options).then(response => {
            setLoading(false);

            if (!filterDate) {
                setAttentionsByExecutive(response.data.attentionsByExecutive);

                //reduce to get count of bot/executive sessions
                let abe=response.data.attentionsByExecutive;
                let allSessions = abe.reduce((acc, att) => acc + att.total, 0);  //handler: 'exec' 
                let execSessions = abe.reduce((acc, att) => acc + (att.handler==='exec'?att.total:0), 0);  
                let botSessions = abe.reduce((acc, att) => acc + (att.handler==='bot'?att.total:0), 0);  

                setAllSessionsCount(allSessions);
                setAllExecSessionsCount(execSessions);
                setAllBotSessionsCount(botSessions);
            
            } else { //fiter by dates
                setAttentionsByExecutiveByDates(response.data.attentionsByExecutive);

                //reduce to get count of bot/executive sessions
                let abe = response.data.attentionsByExecutive;
                let allSessions = abe.reduce((acc, att) => acc + att.total, 0);  //handler: 'exec' 
                let execSessions = abe.reduce((acc, att) => acc + (att.handler === 'exec' ? att.total : 0), 0);
                let botSessions = abe.reduce((acc, att) => acc + (att.handler === 'bot' ? att.total : 0), 0);

                setAllSessionsCountByDates(allSessions);
                setAllExecSessionsCountByDates(execSessions);
                setAllBotSessionsCountByDates(botSessions);
            }

        }).catch(function (error) {
            console.log("Error:", error.message);
            //setError(error.message);
            setLoading(false);
        });
    }

    const getInteractionsCount = (filterDate = null) => {
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatDashboard_interactionsCount`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: {}
        };
        if (filterDate) {
            options.params.filterDate = filterDate;
        }

        axios(options).then(response => {
            setLoading(false);
            if (!filterDate) {
                setInteractionsCount(response.data.interactionsCount);
            } else {
                setInteractionsCountByDates(response.data.interactionsCount);
            }

        }).catch(function (error) {
            console.log("Error:", error.message);
            //setError(error.message);
            setLoading(false);
        });
    }


    const getSessions = (filterDate = null, extension, finished, pagination = null) => {
        setLoading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatDashboard_sessions`,
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            params: { extension: extension, finished: finished }
        };
        if (filterDate) {
            options.params.filterDate = filterDate;
        }

        if (pagination) { options.params.pagination = pagination }

        axios(options).then(response => {
            setLoading(false);
            //setSessions(response.data.sessions[0].data);


            if (pagination) {
                setSessions([...sessions, ...response.data.sessions[0].data]);
            }
            else {
                setSessions(response.data.sessions[0].data);
            }

            setSessionsPagination(response.data.sessions[0].metadata[0]);
        }).catch(function (error) {
            console.log("Error:", error.message);
            //setError(error.message);
            setLoading(false);
        });
    }

    const downloadSessions = (filterDate = null) => {
        setDownloading(true);
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/chatDashboard_sessionsDownload`,
            method: 'POST',
            responseType: 'blob',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {}
        };
        if (filterDate) {
            options.data.filterDate = filterDate;
        }

        axios(options).then(response => {
            setDownloading(false);
            var reportData = response.data,
                // blob = new Blob([reportData], { type: "text/csv" }),
                blob = new Blob([reportData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }),
                url = window.URL.createObjectURL(blob);

            var a = document.createElement('a');
            a.href = url;
            a.download = 'reporte_sesiones_chat.xlsx'; 
            a.click();

            // Clean the URL object created
            window.URL.revokeObjectURL(url);

        }).catch(function (error) {
            console.log("Error:", error.message);
            setDownloading(false);
        });
    }

    const getSessionsList = (executive, filterDate = null, finished = true)=>{
        console.log('🐞DEBUG executive:', executive.extension, filterDate, finished);
        setShowSessionsPopup(true);
        getSessions(filterDate, executive.extension, finished);
        setCurrentSessionsFilter({ f1:filterDate, f2:executive.extension, f3:finished });
        
        //build window title 
        let windowTitle ='Sesiones ';
        if (filterDate === null && !finished) { windowTitle+='en línea '; }
        if (filterDate === null && finished) { windowTitle+='de hoy '; }
        if (filterDate !== null) { windowTitle+='según rango fechas '; }
        windowTitle += executive.name;
        setSessionsWindowTitle(windowTitle);
    }


    const enableContactCenter=(newStatus)=>{
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/enableCC`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: {
                contactCenterEnabled: newStatus
            }
        };

        axios(options).then(response => {
            if (response.status === 200) {
                //console.log('Saved interaction');
                getCcStatus();
            }
        });
    }

    const getCcStatus = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/cCStatus`, {
            params: {}
        })
            .then(function (response) {
                setCurrentStatusContactCenter(response.data.cCStatus);

                //setItem(response.data.item);
                setLoading(false);
            })
            .catch(function (error) {
                console.log("Error:", error.message);
                //setError(error.message);
                setLoading(false);
            });
    }

    const refreshValues=()=>{
        getAttentionsByExecutive();
        getCurrentStatusChatExecutives();
        getInteractionsCount();
    }

    const refreshValuesByDate = () => {
        getAttentionsByExecutive(selectedDayRange);
        getInteractionsCount(selectedDayRange);
    }

    const disconnectChatUser = (executive)=>{
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        const options = {
            url: `${process.env.REACT_APP_URI_API_CRM}/disconnectChatUser`,
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
                'Authorization': currentSessionData.token
            },
            data: {
                userId: executive._id
            }
        };
        axios(options).then(response => {
            if (response.status === 200) {
                console.log('disconnected??????');
            }
        });

    }

    return (
        <div className="mainWrapper">
            <Sidebar key={props.inboundConnectedQueues} current="10" softphoneConnectionStatus={props.softphoneConnectionStatus} />
            <div className="main chatDashboard">

                {showSessionsPopup?(
                    <ModalWindow closeMethod={() => { setShowSessionsPopup(false); setCurrentSessionId(null); setSessions([]) }} width={currentSessionId?'75%':'624px'}>
                        <h3 className='title'>{sessionsWindowTitle}</h3>
                        <div className="flex gap20">
                            <div className="sessionsTableWrapper niceScrollBar">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>ID Sesion</th>
                                            <th>Inicio</th>
                                            <th>Término</th>
                                            <th>Int.</th>
                                            <th>&nbsp;</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sessions.map((chat, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{chat.sessionId}</td>
                                                    <td>{Tools.fdtCL(chat.start)}</td>
                                                    {chat.end ? (<td>{Tools.fdtCL(chat.end)}</td>) : (<td>----</td>)}
                                                    <td>{chat.interactionsCount}</td>
                                                    <td>
                                                        {chat.sessionId!==currentSessionId?(
                                                            <a className='overRound' onClick={() => setCurrentSessionId(chat.sessionId)}><ViewIcon width="23" height="23" /></a>
                                                        ) : (
                                                            <ArrowIcon width="23" height="23" />
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>

                                {
                                    sessionsPagination ? (
                                        <p className="pagination">
                                            Mostrando [{sessions.length} de {sessionsPagination.total} registros]
                                            {(sessions.length < sessionsPagination.total) ? (
                                                <span> &nbsp; <a className={loading ? 'link loading' : 'link'} onClick={() => getSessions(currentSessionsFilter.f1, currentSessionsFilter.f2, currentSessionsFilter.f3, { page: sessionsPagination.page + 1, skip: sessions.length, limit: 10 })}>Ver más</a></span>
                                            ) : null}
                                        </p>
                                    ) : null
                                }

                            </div>
                            {currentSessionId?(
                                interactions.length > 0 ? (
                                    <div className="chatWrapper forDashboard">
                                        <div className="chatContainer niceScrollBar">
                                            {interactions.map((message, index) => {
                                                return (
                                                    <div key={index} className={(message.owner === 'bot' || message.owner === 'exec') ? 'messageRow bot' : message.owner === 'system' ? 'messageRow system ' + message.alertType : 'messageRow user'}>

                                                        {message.owner === 'system' || message.owner === 'exec' || message.owner === 'bot' ? (
                                                            <span className="message">{ReactHtmlParser(message.message)}</span>
                                                        ) : (
                                                            <span className="message">{message.message}</span>
                                                        )}

                                                        <span className='messageInfo'>
                                                            {message.owner === 'bot' ? (<BotIcon width="20" height="20" />)
                                                                : message.owner === 'user' ? (<UserIcon width="20" height="20" />)
                                                                    : message.owner === 'exec' ? (<ExecIcon width="20" height="20" />)
                                                                        : null}

                                                            {message.owner === 'exec' ? (message.executiveName)
                                                                : message.owner === 'user' ? ("Usuario")
                                                                    : message.owner === 'bot' ? ("Bot")
                                                                        : null}

                                                            , &nbsp;
                                                            {Tools.fdtCL(message.date)}
                                                        </span>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ) : null

                            ):null}
                        </div>
                    </ModalWindow>
                ):null}

                <div className="headerWrapper">
                    <div className="titleWrapper">
                        <h1 className={loading ? 'loading' : ''}><DashboardIcon />Dashboard Chats</h1>
                    </div>
                    <UserMenu setInboundConnectedQueues={props.setInboundConnectedQueues} />
                </div>

                <div className="flex gap20 flexSpaceBetween mgb20">
                    {activeTab === 0?(
                        <div className="kpisWrapper">
                            <div className="card interactions"><div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(interactionsCount)}</h3><p>Interacciones</p></div></div>
                            <div className="card allSessions"> <div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allSessionsCount)}</h3><p>Sesiones</p></div></div>
                            <div className="card botSessions"> <div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allBotSessionsCount)}</h3><p>Sesiones sólo Bot/IA</p></div></div>
                            <div className="card execSessions"><div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allExecSessionsCount)}</h3><p>Sesiones ejecutivo</p></div></div>
                        </div>
                    ) : (
                        <div className="kpisWrapper">
                            <div className="card interactions"><div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(interactionsCountByDates)}</h3><p>Interacciones</p></div></div>
                            <div className="card allSessions"> <div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allSessionsCountByDates)}</h3><p>Sesiones</p></div></div>
                            <div className="card botSessions"> <div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allBotSessionsCountByDates)}</h3><p>Sesiones sólo Bot/IA</p></div></div>
                            <div className="card execSessions"><div className="icon"><UserRoundedIcon width="22" height="22" /></div><div className="info"><h3>{Tools.fmtClNumber(allExecSessionsCountByDates)}</h3><p>Sesiones ejecutivo</p></div></div>
                        </div>
                    )}

                    {activeTab === 0 ? (
                        <div className="refreshButton" onClick={refreshValues}>
                            <RefreshIcon width="30" height="30"/>
                        </div>
                    ) : selectedDayRange.to!==null?(
                        <div className="refreshButton" onClick={() => refreshValuesByDate()}>
                            <RefreshIcon width="30" height="30" />
                        </div>
                    ) : null}    
                </div>    

                <Tabs className='tabset'>
                    <Tab onClick={() => { setActiveTab(0); refreshValues()}} active={activeTab === 0} id={0}>Situación diaria</Tab>
                    <Tab onClick={() => setActiveTab(1)} active={activeTab === 1} id={1}>Según fecha</Tab>
                </Tabs>

                <Content active={activeTab === 0} className="tabContent2 niceScrollBar">
                    <div className="totalsWrapper">
                        <div className="wrapper">
                            <div className="xtableWrapper">
                                <div className="flex flexSpaceBetween flexAICenter">
                                    <h3>Sesiones Diarias ({attentionsByExecutive.reduce((acc, att) => acc + att.total, 0)})</h3>
                                    {/* <a className='downloadReport' onClick={() => downloadSessions()}><DownloadIcon width="30" height="30" /></a> */}


                                    <div className="wrapper rel flex flexJCEnd autoWidth">
                                        {!downloading ? (
                                            <a className='downloadReport' onClick={() => setDownloadStart(true)}><DownloadIcon width="30" height="30" /></a>
                                        ) : (
                                            <DownloadingIcon width="30" height="30" color="#808080" />
                                        )}

                                        {downloadStart ? (
                                            <div className='dlPopover'>
                                                <p><b>Atención</b>: Por favor tenga en cuenta que la descarga de este reporte podría tomar un tiempo variable dependiendo de la velocidad de su conexión a internet y de la cantidad de datos a procesar.</p>
                                                <div className="flex gap10 flexJCenter">
                                                    <button className='outline' onClick={() => setDownloadStart(false)}>Cancelar</button>
                                                    <button onClick={() => { downloadSessions(); setDownloadStart(false) }}>Iniciar Descarga</button>
                                                </div>
                                            </div>
                                        ) : null}
                                    </div>




                                </div>
                                <table>
                                    <thead><tr><th>Ejecutivo</th><th className='right'>Sesiones</th><th>&nbsp;</th></tr></thead>
                                    <tbody>
                                        {attentionsByExecutive.map((attention, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{attention.name}</td>
                                                    <td className='right'>{attention.total}</td>
                                                    <td><a className='overRound' disabled={attention.total===0} onClick={() => getSessionsList(attention)}><ViewIcon width="23" height="23" /></a></td>
                                                </tr>
                                            )}
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="wrapper">
                            <div className="xtableWrapper">
                                <h3>Sesiones En Línea ({currentStatusChatExecutives.reduce((acc, exec) => acc + exec.activeChatSessionsCounter, 0)})</h3>
                                <table>
                                    <thead><tr><th>Ejecutivo</th><th>Estado</th><th>Desde</th><th className='right'>Sesiones</th><th>&nbsp;</th><th>&nbsp;</th></tr></thead>
                                    <tbody>
                                        {currentStatusChatExecutives.map((executive, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{executive.name}</td>
                                                    <td><span className={'tagUserStatus ' + executive.currentStatus.toLowerCase()}>{executive.currentStatusDesc}</span></td>
                                                    
                                                    {executive.eventStartDate?(
                                                        <td className='mutted'><ReactTimeAgo date={new Date(executive.eventStartDate)} timeStyle="twitter" /></td>
                                                    ) : (
                                                        <td>-</td>
                                                    )}

                                                    <td className='right'>{executive.activeChatSessionsCounter}</td>
                                                    <td><a className='overRound' disabled={executive.activeChatSessionsCounter === 0} onClick={() => getSessionsList(executive, null, false)}><ViewIcon width="23" height="23"/></a></td>
                                                    <td>
                                                        {executive.profileCode ==="EXEC_CHAT"?(
                                                            executive.currentStatus !=="LOGOUT"?(
                                                                <MoreMenu menuList={[{ title: "Desconectar", action: () => { disconnectChatUser(executive) }, visible: true }]}/>
                                                            ) : null
                                                        ) : null}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Content>

                <Content active={activeTab === 1} className="tabContent2 niceScrollBar">
                    <div className="xtableWrapper">
                        <div className="flex flexSpaceBetween flexAICenter dashbrdTitle">
                            <div className="inlineFlex flexAICenter gap20">
                                <h3>Sesiones del período ({attentionsByExecutiveByDates.reduce((acc, att) => acc + att.total, 0)})</h3>
                                <div className="calendarWrapper">
                                    <DatePicker
                                        value={selectedDayRange}
                                        onChange={setSelectedDayRange}
                                        inputPlaceholder="Seleccione rango de consulta"
                                        locale={Tools.customLocaleSpanish}
                                        shouldHighlightWeekends
                                        maximumDate={Tools.getNowForRMCD()}
                                    />
                                    <CalendarIcon/>
                                </div>
                            </div>
                            {selectedDayRange.to !== null?(
                                <div className="wrapper rel">
                                    {!downloading?(
                                        <a className='downloadReport' onClick={() => setDownloadStart(true)}><DownloadIcon width="30" height="30" /></a>
                                    ) : (
                                        <DownloadingIcon width="30" height="30" color="#808080" />
                                    )}
                                    
                                    {downloadStart?(
                                        <div className='dlPopover'>
                                            <p><b>Atención</b>: Por favor tenga en cuenta que la descarga de este reporte podría tomar un tiempo variable dependiendo de la velocidad de su conexión a internet y del rango de fechas especificado en el filtro.</p>
                                            <div className="flex gap10 flexJCenter">
                                                <button className='outline' onClick={() => setDownloadStart(false)}>Cancelar</button>
                                                <button onClick={() => { downloadSessions(selectedDayRange); setDownloadStart(false)}}>Iniciar Descarga</button>
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            ) : null}
                            
                        </div>
                        <table>
                            <thead><tr><th>Ejecutivo</th><th className='right'>Sesiones</th><th>&nbsp;</th></tr></thead>
                            <tbody>
                                {attentionsByExecutiveByDates.map((attention, index) => {
                                    return (
                                        <tr>
                                            <td>{attention.name}</td>
                                            <td className='right'>{attention.total}</td>
                                            <td><a className='overRound' disabled={attention.total === 0} onClick={() => getSessionsList(attention, selectedDayRange )}><ViewIcon width="23" height="23" /></a></td>
                                        </tr>
                                    )
                                }
                                )}
                            </tbody>
                        </table>
                    </div>

                </Content>


                

                {!loading && sessionData.profile_code === 'EXEC_CHAT_REB' ?(
                    <div className='switchWrapper'>
                        <label className="switch">
                            <input type="checkbox" defaultChecked={currentStatusContactCenter} onChange={handleChange}/>
                            <div></div>
                        </label>

                        {currentStatusContactCenter ? (<span>Contact Center Habilitado</span>) : (<span>Contact Center Deshabilitado</span>)}
                    </div>
                ):null}
                



            </div>


        </div>
    );

}

export default ChatDashboard;
